exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Grid-module__grid___2TVzv{display:grid;grid-template-columns:repeat(auto-fill,minmax(310px,1fr));grid-auto-rows:minmax(200px,1fr);max-width:100%;gap:32px;grid-auto-flow:dense}@media (max-width:800px){.Grid-module__grid___2TVzv{grid-template-columns:1fr;grid-auto-rows:auto}.Grid-module__grid___2TVzv .Grid-module__item___2UUVr.Grid-module__invisible___DMeZj{display:none!important}}", ""]);

// exports
exports.locals = {
	"grid": "Grid-module__grid___2TVzv",
	"item": "Grid-module__item___2UUVr",
	"invisible": "Grid-module__invisible___DMeZj"
};